"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const charts_1 = require("@amcharts/amcharts4/charts");
const am4core = require("@amcharts/amcharts4/core");
// license of charts
am4core.addLicense("CH227989214");
// license of timeline
am4core.addLicense("TL227989214");
class ChartBaseControl {
    /**
     * Public method for getting chart as image
     */
    getExportedImage() {
        return this.chart.exporting.getImage("png");
    }
    /**
     * Calculates image width and height for export taking into account A4 format size.
     */
    getExportWidthHeight() {
        let [width, height] = this.chart.exporting.getPageSizeFit("A4", 30);
        let ratio = this.chart.measuredWidth / this.chart.measuredHeight > width / height ? width / this.chart.measuredWidth : height / this.chart.measuredHeight;
        return [Math.round(this.chart.measuredWidth * ratio), Math.round(this.chart.measuredHeight * ratio)];
    }
    setLegendDefaultOptions() {
        // Legend Options
        this.chart.legend = new charts_1.Legend();
        this.chart.legend.valueLabels.template.text = '';
        this.chart.legend.labels.template.paddingTop = 2;
        this.chart.legend.labels.template.maxWidth = 120;
        this.chart.legend.labels.template.contentHeight = 10;
        this.chart.legend.labels.template.fontSize = 12;
        this.chart.legend.labels.template.truncate = true;
        this.chart.legend.markers.template.width = 14;
        this.chart.legend.markers.template.height = 14;
        this.chart.legend.marginTop = 24;
    }
}
exports.ChartBaseControl = ChartBaseControl;
//# sourceMappingURL=chart-base.control.js.map